import CompanyDocument from './CompanyDocument';
import AttachedDocument from './AttachedDocument';

export {
  CompanyDocument,
  AttachedDocument
};
